<div [ngClass]="spinnerClass" class="spinner-ring spinner-ring--centered">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>

